import React, { Component } from 'react';
import PostJobView from './PostJobView';
import { PostJobApi, PostShiftApi } from './Api';
import Moment from 'moment';
import { url } from '../../Server/url/GlobalUrl';

class PostJobComponent extends Component {
  state = {
    carer_type: [],
    language: [],
    qualification: [],
    job_title: '',
    description: '',
    patient_name: 'patient name',
    address: '',
    address_list: [],
    patient_address_one: '',
    patient_address_two: '',
    patient_address_three: '',
    city: '',
    postcode: '',
    phone: '',
    week_days: {
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
    },
    start_date: '',
    qualification_input: '',
    renumerate: '',
    closing_date: '',

    weeek_check_boxes: [false, false, false, false, false, false, false],
    language_input: '',
    terms: false,
    sd_start_time: '',
    sd_end_time: '',
    ed_start_time: '',
    ed_end_time: '',
    end_date: '',
    incentive: '',
    sd_time_validation: '',
    ed_time_validation: '',
    patient_name_validate: '',
    authResponse: '',
    modal_show: false,
    custom_model: false,
    modal_boolean: false,
    Success_modal_boolean: false,
    modal_id: '',
    contract_type: [],
    contract_type_input: '',
    contract_type_input_string: '',
    job_type: ['private', 'Council', 'Nursing Home'],
    job_type_input: '',
    qualification_list: [],
    selected_qualification: [],
    experience: [],
    experience_input: '',

    start_date_list: ['onemore'],

    shift_select_timing: [
      'Morning Shift - 5am to 9am',
      'Mid Morning shift - 9am to noon',
      'Day Shift - 7am to 6pm',
      'Afternoon Shift - Noon to 4pm',
      'Twilight Shift - 4pm to 10pm',
      'Night Shift - 4pm to 8am',
      'Swing Shift 10pm - 10am',
      'Grave Shift - midnight to 10am',
      'On-Call Shift - anytime day or night ',
      'Weekend Shift - weekends only ',
    ],

    end_date_list: ['onemore'],
    hr_list: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
    ],
    min_list: [
      '00',
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
      '32',
      '33',
      '34',
      '35',
      '36',
      '37',
      '38',
      '39',
      '40',
      '41',
      '42',
      '43',
      '44',
      '45',
      '46',
      '47',
      '48',
      '49',
      '50',
      '51',
      '52',
      '53',
      '54',
      '56',
      '57',
      '58',
      '59',
    ],
    repeate_list: ['Daily', 'Weekly', 'Semi Weekly', 'Monthly'],
    shift_data: [],
    start_date: '',
    shift_timing: '',
    end_date: '',
    start_carer_type: '',
    start_repeate_type: '',
    carer_input: '',

    start_quantity: '',
    end_carer_type: '',
    end_repeate_type: '',

    end_quantity: '',

    start_in_date: '00:00',
    start_out_date: '00:00',
    index: 0,
    shift_select_list: [],
    select_all: false,
    all_training: false,
  };
  /*********
   *****
   */

  /* AVAIA*/

  allTrainingHandle = (e) => {
    console.log(e);
    this.setState({ all_training: !this.state.all_training });
  };

  hideAvailablityModal = () => {
    this.setState({ modal_boolean: false });
  };

  showAvailablityModal = () => {
    this.setState({ modal_boolean: true });
  };

  showSuccessModal = () => {
    this.setState({ Success_modal_boolean: true });
  };

  hideSuccessModal = () => {
    this.setState({ Success_modal_boolean: false });
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
  };
  showCustomModal = () => {
    this.setState({ modal_show: true });
  };
  setWeekDay = (option, value, id) => {
    const values = [
      'monday',
      'tuesday',
      'wednesday',
      'thursday',
      'friday',
      'saturday',
      'sunday',
    ];
    console.log('value changed of ', option + ' ' + value);
    const week_copy = this.state.week_days;
    week_copy[values[id]] = value;
    console.log(week_copy);
    this.state.weeek_check_boxes[id] = !this.state.weeek_check_boxes[id];
    this.setState({ weeek_check_boxes: this.state.weeek_check_boxes });
    this.setState({ week_days: week_copy });
  };

  changeValue = (e) => {
    console.log(e.ta);
    this.setWeekDay(e.target.name, e.target.checked, e.target.id);
  };
  weekDaysOnly = (e) => {
    if (e.target.checked) {
      var week_check = this.state.weeek_check_boxes;
      week_check[6] = false;
      week_check[5] = false;

      this.state.week_days['saturday'] = false;
      this.state.week_days['sunday'] = false;

      this.setState({ week_days: this.state.week_days });
      this.setState({ weeek_check_boxes: week_check });

      // this.setState({weeek_check_boxes:this.state.weeek_check_boxes});

      console.log(this.state.weeek_check_boxes);
      console.log(this.state.week_days);
    } else {
      // e.target.checked = false;
      // this.state.weeek_check_boxes[5] = true;
      // this.state.weeek_check_boxes[6] = true;
      // this.setState({weeek_check_boxes:this.state.weeek_check_boxes});
    }
  };

  //   'start_carer_type': '','start_repeate_type': '','start_date': '','start_in_hh': '','start_in_mm': '','start_out_hh': '','start_out_mm': '','start_quantity'
  handelextrenssion = (identity) => {
    console.log('identity', identity);
    if (identity === 'startdate') {
      this.state.start_date_list.push('addmore');
      this.setState({ start_date_list: this.state.start_date_list });
      console.log(this.start_date_list);
      var i;
      for (i = 1; i < this.state.start_date_list.length; i++) {
        console.log('Hello all', i);
        var data = {
          end_carer_type: '',
          end_repeate_type: '',
          end_date: '',
          end_quantity: '',
        };
        this.state.shift_data.push(data);
        this.setState({ shift_data: this.state.shift_data });
      }
    } else if (identity === 'enddate') {
      this.state.end_date_list.push('addmore');
      this.setState({ end_date_list: this.state.end_date_list });
    }
    console.log('start_date_list', this.state.end_date_list);
  };
  handelcompression = (identity) => {
    console.log('identity', identity);
    if (identity === 'startdate') {
      const index = this.state.start_date_list.indexOf('addmore');
      if (index > -1) {
        this.state.start_date_list.splice(index, 1);
      }

      this.setState({ start_date_list: this.state.start_date_list });
    } else if (identity === 'enddate') {
      const index = this.state.end_date_list.indexOf('addmore');
      if (index > -1) {
        this.state.end_date_list.splice(index, 1);
      }

      this.setState({ end_date_list: this.state.end_date_list });
    }
    console.log('start_date_list', this.state.start_date_list);
  };
  handleMinusData = (identity, index) => {
    console.log(index, identity);
    if (identity == 'startdate') {
      const a = this.state.shift_select_list;
      delete a[index];
      this.setState({
        shift_data: this.state.shift_data.filter((value, i) => index != i),
      });
      console.log(this.state.shift_data.filter((value, i) => index != i));
      console.log(a);
      this.setState({ shift_select_list: a });
    } else if (identity == 'enddate') {
      const a = this.state.shift_select_list;
      delete a[index].end_string;
      this.setState({ shift_select_list: a });
    }
  };
  componentDidMount() {
    let data_refresh = { refresh: localStorage.getItem('refresh') };
    fetch(url + '/api/token/refresh/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data_refresh),
    })
      .then((response) => {
        if (response['status'] === 201 || response['status'] === 200) {
          return response.json();
        } else if (response['status'] === 401) {
          this.showCustomModal();
          this.setState({ authResponse: 'Some Thing went wrong' });
          localStorage.removeItem('refresh');
          localStorage.removeItem('token');
          localStorage.removeItem('is_admin');
        }
      })
      .then((result) => {
        if (result) {
          console.log('result.access', result.access);
          localStorage.setItem('token', result.access);
        }
      });
    fetch(url + '/jobs/contract-type/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ contract_type: result });
          console.log('contract_type', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/jobs/carer-type/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.length > 0) {
            this.setState({ carer_type: result });
            console.log('result', result);
          }
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/jobs/qualification/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ qualification: result });
          console.log('qualification______________result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/jobs/experience/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ experience: result });
          console.log('result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
    fetch(url + '/jobs/language/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ language: result });
          console.log('result', result);
        },
        (error) => {
          console.log('error', error);
        }
      );
  }
  get_data_for_qualification = (list) => {
    var return_val = [];
    for (var each of this.state.qualification) {
      for (var dt of list) {
        if (dt === each.type) {
          return_val.push(each.id);
        }
      }
    }
    return return_val;
  };

  getDataPostCode = () => {
    var data = this.state.postcode.replaceAll(' ', '');
    this.setState({ address_list: [] });
    this.setState({ address: '' });
    if (data.length > 5) {
      console.log('DSD');
      fetch(
        'https://api.getaddress.io/find/' +
          data +
          '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608',
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
        .then((res) => {
          if (res.status == 400) {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter the valid UK postcode',
            });
            this.setState({ postcode: '' });
          }

          return res.json();
        })
        .then(
          (result) => {
            console.log(
              'postcode',
              typeof result,
              result,
              Object.keys(result).length
            );
            if (Object.keys(result).length > 1) {
              this.setState({ address_list: result.addresses });

              //     console.log(this.state.address)
              // }else{
              //     this.setState({address:""})
            }
          },
          (error) => {
            console.log('error', error);
          }
        );
    } else {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the valid UK postcode' });
      this.setState({ postcode: '' });
    }
  };

  handelData = (identity, data) => {
    console.log('hello', data);
    console.log('identity', identity);
    if (identity === 'title') {
      console.log('data', data);
      this.setState({ job_title: data });
    } else if (identity === 'description') {
      console.log('data', data);
      this.setState({ description: data });
    } else if (identity === 'row_start_date') {
      this.setState({ row_start_date: data });
    } else if (identity === 'row_end_date') {
      this.setState({ row_end_date: data });
    } else if (identity === 'patient_name') {
      console.log('data', data);
      if (/^([a-zA-Z]+[,.]?[ ]?|[a-zA-Z]+['-]?)+$/.test(data)) {
        this.setState({ patient_name: data });
        this.setState({ patient_name_validate: '' });
      } else if (data.length <= 0) {
        this.setState({ patient_name_validate: '' });
      } else {
        this.setState({
          patient_name_validate: 'Please Enter a valid patient name',
        });
      }
    } else if (identity === 'patient_address_one') {
      console.log('data', data);
      this.setState({ patient_address_one: data });
    } else if (identity === 'patient_address_two') {
      console.log('data', data);
      this.setState({ patient_address_two: data });
    } else if (identity === 'city') {
      console.log('data', data);
      this.setState({ city: data });
    } else if (identity === 'postcode') {
      console.log('data', data);
      this.setState({ postcode: data });
    } else if (identity == 'job_address') {
      var postcode = this.state.postcode;
      this.setState({ address: data });
      if (data) {
        fetch(
          'https://api.getaddress.io/find/' +
            postcode +
            '/' +
            data +
            '?api-key=O-vbZ8Cu4EqwX9XPa_ERLw29608&expand=true',
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
            },
          }
        )
          .then((res) => {
            if (res.status == 400) {
              console.log('Not found');
            } else if (res.status == 200 || res.status == 201) {
              return res.json();
            }
          })
          .then((result) => {
            console.log('expand address', result);
            this.setState({
              city:
                result['addresses'][0]['district'] +
                ',' +
                result['addresses'][0]['town_or_city'],
            });
            this.setState({ country: result['addresses'][0]['country'] });
            this.setState({ county: result['addresses'][0]['county'] });
            this.setState({
              patient_address_one: result['addresses'][0]['line_1'],
            });
            this.setState({
              patient_address_two: result['addresses'][0]['line_2'],
            });
            this.setState({
              patient_address_three: result['addresses'][0]['line_3'],
            });
            this.setState({ latitude: result.latitude });
            this.setState({ longitude: result.longitude });
          });
      }
    } else if (identity === 'phone') {
      console.log('data', data);
      this.setState({ phone: data });
    } else if (identity === 'incentive') {
      console.log('data', data);
      this.setState({ incentive: data });
    } else if (identity === 'qualification_input') {
      console.log('data', data);
      this.setState({ qualification_input: data });
    } else if (identity === 'renumerate') {
      console.log('data', data);
      this.setState({ renumerate: data });
    } else if (identity === 'incentive') {
      console.log('data', data);
      this.setState({ incentive: data });
    } else if (identity === 'contract_type_input') {
      console.log('data', data);
      this.setState({ contract_type_input: data });

      for (var i = 0; i < this.state.contract_type.length; i++) {
        console.log(
          'this.state.contract_type_input_string',
          this.state.contract_type[i]['id'],
          data
        );
        if (this.state.contract_type[i]['id'].toString() === data.toString()) {
          console.log('Helllo');
          this.setState({
            contract_type_input_string: this.state.contract_type[i]['type'],
          });
        }
        console.log(
          'this.state.contract_type_input_string',
          this.state.contract_type_input_string
        );
      }
    } else if (identity === 'language_input') {
      console.log('data', data);
      this.setState({ language_input: data });
    } else if (identity === 'terms') {
      console.log('data', data);
      this.setState({ terms_agreed: data });
    } else if (identity === 'sd_start_time') {
      console.log('data', data);
      var regExp =
        /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/i;
      if (regExp.test(data)) {
        console.log('incorrect');
        this.setState({ sd_start_time: data });
        this.setState({ sd_time_validation: '' });
      } else {
        this.setState({ sd_time_validation: 'please Enter the valid time' });
        console.log('correct');
      }
    } else if (identity === 'sd_end_time') {
      console.log('data', data);
      var regExp =
        /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/i;
      if (regExp.test(data)) {
        console.log('incorrect');
        this.setState({ sd_end_time: data });
        this.setState({ sd_time_validation: '' });
      } else {
        this.setState({ sd_time_validation: 'please Enter the valid time' });
        console.log('correct');
      }
    } else if (identity === 'ed_start_time') {
      console.log('data', data);
      var regExp =
        /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/i;
      if (regExp.test(data)) {
        console.log('incorrect');
        this.setState({ ed_start_time: data });
        this.setState({ ed_time_validation: '' });
      } else {
        this.setState({ ed_time_validation: 'please Enter the valid time' });
        console.log('correct');
      }
    } else if (identity === 'ed_end_time') {
      console.log('data', data);
      var regExp =
        /^(([0-1]?[0-9])|([2][0-3])):([0-5]?[0-9])(:([0-5]?[0-9]))?$/i;
      if (regExp.test(data)) {
        console.log('incorrect');
        this.setState({ ed_end_time: data });
        this.setState({ ed_time_validation: '' });
      } else {
        this.setState({ ed_time_validation: 'please Enter the valid time' });
        console.log('correct');
      }
    } else if (identity === 'job_type_input') {
      this.setState({ job_type_input: data });
      console.log('job_type_input', data);
    } else if (identity === 'experience_input') {
      this.setState({ experience_input: data });
      console.log('experience_input', data);
    }
  };

  handelshiftData = async () => {
    console.log('this.state.start_carer_type', this.state.start_carer_type);
    var data_post = {
      weekdays: JSON.stringify(this.state.week_days),
      start_date: this.state.start_date,
      start_carer_type: this.state.start_carer_type,
      start_repeate: this.state.start_repeate_type,
      start_quantity: this.state.start_quantity,
      shift_availablity: this.state.shift_timing,
      start_date_arrival_time: this.state.start_in_date + ':00',
      start_date_departure_time: this.state.start_out_date + ':00',
      end_carer_type: 3,
    };
    console.log(data_post);

    if (this.state.start_date === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'please enter Start Date' });
    } else if (this.state.description === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'please enter description' });
    } else if (this.state.start_carer_type === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the carer type' });
    } else if (this.state.start_repeate_type === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the Repeat type' });
    }
    // else if(this.state.start_in_date === "" ){
    //     this.showCustomModal();
    //     this.setState({authResponse:"Please enter the Start time"});
    // }

    // else if(this.state.start_out_date === "" ){
    //     this.showCustomModal();
    //     this.setState({authResponse:"Please enter the End time"});
    // }
    else if (this.state.start_quantity === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the quantity' });
    } else if (Number(this.state.start_quantity) > 15) {
      this.showCustomModal();
      this.setState({ authResponse: 'You can enter maximum 15 quanttity' });
    } else if (Number(this.state.start_quantity) < 1) {
      this.showCustomModal();
      this.setState({ authResponse: 'You can enter minimum 1 quanttity' });
    } else if (!Object.values(this.state.week_days).includes(true)) {
      this.showCustomModal();
      this.setState({ authResponse: 'Please select the week days' });
    } else if (this.state.shift_timing === '') {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the shift' });
    } else if (
      (this.state.contract_type_input_string == 'Temporary' ||
        this.state.contract_type_input == 'Emergency') &&
      this.state.end_date === ''
    ) {
      this.showCustomModal();
      this.setState({ authResponse: 'Please enter the end Date' });
      return;
    } else if (
      this.state.start_date != '' &&
      this.state.start_carer_type != '' &&
      this.state.start_repeate_type != '' &&
      this.state.shift_timing != '' &&
      this.state.start_in_date != '' &&
      this.state.start_out_date != '' &&
      this.state.start_quantity != '' &&
      Object.values(this.state.week_days).includes(true)
    ) {
      if (this.state.start_in_date === this.state.start_out_date) {
        this.showCustomModal();
        this.setState({
          authResponse: 'End time should be not be same as start time',
        });
        return;
      }

      console.log('Hello all this is text', this.state.start_carer_type);
      var start_string = '';
      var end_string = '';
      var days = '';
      for (var each in this.state.week_days) {
        if (this.state.week_days[each] === true) {
          days += each[0].toUpperCase() + '-';
        }
      }
      days = days.slice(0, days.length - 1);

      if (this.state.start_carer_type == '1') {
        if (this.state.end_date) {
          start_string =
            this.state.start_quantity +
            ' Carer(s)' +
            ' ' +
            this.state.start_repeate_type +
            ' ' +
            days +
            ' starting on ' +
            this.state.start_date +
            ' ending on ' +
            this.state.end_date +
            ' from ' +
            this.state.start_in_date +
            ' to ' +
            this.state.start_out_date;
        } else {
          start_string =
            this.state.start_quantity +
            ' Carer(s)' +
            ' ' +
            this.state.start_repeate_type +
            ' ' +
            days +
            ' on ' +
            this.state.start_date +
            ' from ' +
            this.state.start_in_date +
            ' to ' +
            this.state.start_out_date;
        }
        // end_string = this.state.end_quantity + ' Carer' + ' ' +  this.state.end_repeate_type + ' begins ' + this.state.end_date + ' from ' + this.state.end_in_hh + ':' + this.state.end_in_mm + ' to ' + this.state.end_out_hh + ':' + this.state.end_in_mm
      } else if (this.state.start_carer_type == '2') {
        if (this.state.end_date) {
          start_string =
            this.state.start_quantity +
            ' Nurse(s)' +
            ' ' +
            this.state.start_repeate_type +
            ' ' +
            days +
            ' starting on ' +
            this.state.start_date +
            ' ending on ' +
            this.state.end_date +
            ' from ' +
            this.state.start_in_date +
            ' to ' +
            this.state.start_out_date;
        } else {
          start_string =
            this.state.start_quantity +
            ' Nurse(S)' +
            ' ' +
            this.state.start_repeate_type +
            ' ' +
            days +
            ' on ' +
            this.state.start_date +
            ' from ' +
            this.state.start_in_date +
            ' to ' +
            this.state.start_out_date;
        } // end_string = this.state.end_quantity + ' Nurses' + ' ' +  this.state.end_repeate_type + ' begins ' + this.state.end_date + ' from ' + this.state.end_in_hh + ':' + this.state.end_in_mm + ' to ' + this.state.end_out_hh + ':' + this.state.end_in_mm
      }
      var data_post = {
        weekdays: JSON.stringify(this.state.week_days),
        start_date: this.state.start_date,
        end_date: this.state.end_date,
        start_carer_type: this.state.start_carer_type,
        start_repeate: this.state.start_repeate_type,
        start_quantity: this.state.start_quantity,
        shift_type: this.state.shift_select_timing.indexOf(
          this.state.shift_timing
        ),
        start_date_arrival_time: this.state.start_in_date + ':00',
        start_date_departure_time: this.state.start_out_date + ':00',
        end_carer_type: this.state.start_carer_type,
      };
      var new_data = this.state.shift_data;
      new_data.push(data_post);
      // this.state.shift_data.push
      // this.state.shift_data.push(data_post)
      this.setState({ shift_data: new_data });
      // const data_post  = {
      //     "start_date": "2029-11-19",
      //     "start_date_arrival_time": "12:30:00",
      //     "start_date_departure_time": "13:20:00",

      //     "start_quantity": "1",
      //     "end_quantity": "1",
      //     "start_repeate": "Weekly",
      //     "end_repeate": "1",
      //     "job": "23",
      //     "start_carer_type": 3,
      //     "end_carer_type": 3
      // }

      // console.log('start_string',start_string)
      // await PostShiftApi(data_post);
      console.log('end_string', end_string);
      let data_string = { start_string: start_string };
      this.state.shift_select_list.push(data_string);
      this.setState({ shift_select_list: this.state.shift_select_list });
      this.setState({
        start_date: '',
        end_date: '',
        start_carer_type: '',
        start_repeate_type: '',
        start_in_date: '',
        start_quantity: '',
        end_carer_type: '',
        end_repeate_type: '',
        start_out_date: '',
        shift_timing: '',
        weeek_check_boxes: [false, false, false, false, false, false, false],
        week_days: {
          monday: false,
          tuesday: false,
          wednesday: false,
          thursday: false,
          friday: false,
          saturday: false,
          sunday: false,
        },
      });
    }
  };

  handleLangChange = (identity, data) => {
    console.log('data', data);
    if (identity === 'start_date') {
      console.log('identity', identity);
      var date = Moment(data).format('YYYY-MM-DD');
      console.log('data', data);
      this.setState({ start_date: date });
    } else if (identity === 'end_date') {
      console.log('data', data);
      var date = Moment(data).format('YYYY-MM-DD');

      this.setState({ end_date: date });
    } else if (identity === 'close_date') {
      console.log('data', data);
      var date = Moment(data).format('YYYY-MM-DD');
      this.setState({ closing_date: date });
    }
  };
  handelSummit = async () => {
    console.log('on apply', this.state.title);
    if (
      this.state.sd_time_validation === '' ||
      this.state.carer_type_input === '' ||
      this.state.patient_name_validate === '' ||
      this.state.ed_time_validation === ''
    ) {
      if (this.state.terms_agreed) {
        if (
          this.state.contract_type_input === '' ||
          this.state.phone === '' ||
          this.state.postcode === '' ||
          this.state.address === '' ||
          this.state.language_input === '' ||
          this.state.selected_qualification.length === 0 ||
          this.state.closing_date === '' ||
          this.state.renumerate === '' ||
          this.state.renumerate < 0 ||
          this.state.incentive === '' ||
          this.state.experience_input === '' ||
          this.state.shift_select_list.length === 0
        ) {
          console.log('INSIDE');
          var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

          if (this.state.job_title === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'please fill the title' });
          } else if (this.state.description === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'please fill the description' });
          } else if (
            this.state.patient_name_validate !== '' ||
            this.state.patient_name === ''
          ) {
            this.showCustomModal();
            this.setState({
              authResponse: 'please enter a valid patient name',
            });
          } else if (this.state.postcode === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter the postcode' });
          } else if (this.state.address === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'Please Select the  address ' });
          } else if (
            format.test(this.state.phone) ||
            this.state.phone === '' ||
            this.state.phone.length < 8 ||
            this.state.phone.length > 10
          ) {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter the valid number' });
          } else if (this.state.job_type_input === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter the job type' });
          } else if (this.state.contract_type_input === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'Please select the Contract Type' });
          } else if (this.state.qualification_list.length === 0) {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter the qualification or training',
            });
          } else if (this.state.experience_input === '') {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter your experience level',
            });
          } else if (
            this.state.renumerate === '' ||
            this.state.renumerate < 0
          ) {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter your hourly rate' });
          } else if (this.state.incentive === '') {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter the perks or incentives',
            });
          } else if (this.state.closing_date === '') {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter the closing date' });
          } else if (this.state.language_input === '') {
            this.showCustomModal();
            this.setState({
              authResponse: 'Please enter your prefered language',
            });
          } else if (this.state.shift_select_list.length === 0) {
            this.showCustomModal();
            this.setState({ authResponse: 'Please enter the shifts' });
          }
          // else if(this.state.)
          // this.showCustomModal()
          // this.setState({ authResponse: 'please fill the form for posting the details' })
        } else {
          console.log('this.state.terms', this.state.terms);
          var data = {
            title: this.state.job_title,
            description: this.state.description,
            postcode: this.state.postcode.replaceAll(' ', ''),
            patient_name: this.state.patient_name,
            phone_number: this.state.phone,
            renumerate: this.state.renumerate + ' £',
            incentive: this.state.incentive,
            address: this.state.address,
            close_date: this.state.closing_date,
            terms_agreed: this.state.terms_agreed,
            carertype: this.state.carer_input,
            language: this.state.language_input,
            qualification: this.get_data_for_qualification(
              this.state.qualification_list
            ),
            contract_type: this.state.contract_type_input,
            job_type: this.state.job_type_input,
            experience: this.state.experience_input,
            patient_address_one: this.state.patient_address_one,
            patient_address_two: this.state.patient_address_two,
            patient_address_three: this.state.patient_address_three,
            archive: this.state.all_training,
            city: this.state.city,
            country: this.state.country,
            county: this.state.county,
            longitude: this.state.longitude,
            latitude: this.state.latitude,
          };
          await PostJobApi(data, this);
        }
      } else {
        this.showCustomModal();
        this.setState({
          authResponse: 'please accept the terms and conditions',
        });
      }
    } else {
      this.showCustomModal();
      this.setState({
        authResponse: 'Please make sure all details are correct',
      });
    }
  };
  availablitydada = (e) => {
    console.log('daat', e.target.value, e.target.checked);
    let new_qualification_list = [...this.state.qualification_list];
    let new_selected_qualification = [];
    if (e.target.checked) {
      new_qualification_list.push(e.target.value);
    } else {
      const index = new_qualification_list.indexOf(e.target.value);
      if (index > -1) {
        new_qualification_list.splice(index, 1);
      }
    }

    this.setState({ qualification_list: new_qualification_list });
    console.log('qualification_list___________', new_qualification_list);
    new_qualification_list.map((q) => {
      new_selected_qualification = new_selected_qualification + q + ', ';
    });
    new_selected_qualification = new_selected_qualification.slice(0, -2);
    console.log(
      'new_selected_qualification___________',
      new_selected_qualification
    );
    this.setState({ selected_qualification: new_selected_qualification });
  };

  selectAllHandler = (e) => {
    let new_qualification = [];
    let new_selected_qualification = [];
    this.setState({ select_all: !this.state.select_all });
    if (e.target.checked) {
      this.state.qualification.map((q) => {
        new_qualification.push(q.type);
        new_selected_qualification = new_selected_qualification + q.type + ', ';
      });
    }

    console.log('qualification', this.state.qualification);
    console.log('new_qualification', new_qualification);
    console.log('new_selected_quali', new_selected_qualification);
    this.setState({ qualification_list: new_qualification });
    new_selected_qualification = new_selected_qualification.slice(0, -2);
    this.setState({ selected_qualification: new_selected_qualification });
  };

  SummitAvailablity = () => {
    console.log('data success', this.state.qualification_list);
    console.log('selected_qualification', this.state.selected_qualification);
    this.hideAvailablityModal();
  };

  handelShift = (identity, data, index) => {
    console.log('index', index);
    console.log('data', data);

    console.log('identity', identity);
    console.log('shift_data', this.state.shift_data);
    if (identity === 'start_date') {
      console.log('identity', identity);
      var date = Moment(data).format('YYYY-MM-DD');
      var data = date;
      console.log(data);
      this.setState({ start_date: data });
      if (new Date(data).getTime() > new Date(this.state.end_date).getTime()) {
        console.log('DDDdD', data);
        this.setState({ end_date: '' });
        console.log(this.state.end_date);
      }
    } else if (identity === 'end_date') {
      console.log('data', data);
      var date = Moment(data).format('YYYY-MM-DD');
      var data = date;
      this.setState({ end_date: data });
    } else if (identity === 'start_carer_type') {
      console.log('CARRER TYPE', data);
      this.setState({ start_carer_type: data });
      this.setState({ carer_input: data });
    } else if (identity === 'start_repeate_type') {
      if (data === 'Daily') {
        for (let val in this.state.week_days) {
          this.state.week_days[val] = true;
        }
        this.setState({ week_days: this.state.week_days });
        this.setState({
          weeek_check_boxes: this.state.weeek_check_boxes.fill(true, 0),
        });
      }
      this.setState({ start_repeate_type: data });
    } else if (identity === 'start_in_date') {
      if (!data) {
        this.setState({ start_in_date: '00:00' });
      }
      this.setState({ start_in_date: data });
    } else if (identity === 'start_out_date') {
      if (!data) {
        this.setState({ start_in_date: '00:00' });
      }
      this.setState({ start_out_date: data });
    } else if (identity === 'start_quantity') {
      this.setState({ start_quantity: data });
      console.log('Start quantity');
    } else if (identity == 'shift-timing') {
      this.setState({ shift_timing: data });
    } else if (identity === 'end_carer_type') {
      this.setState({ end_carer_type: data });
    } else if (identity === 'end_repeate_type') {
      this.setState({ end_repeate_type: data });
    } else if (identity === 'end_quantity') {
      this.setState({ end_quantity: data });
    }

    console.log(
      this.state.start_date,
      this.state.end_date,
      this.state.start_carer_type,
      this.state.start_repeate_type,
      this.state.start_quantity,
      this.state.end_carer_type,
      this.state.end_repeate_type
    );
    console.log(this.state.end_date);

    console.log('THIS IS THE quantity', this.state.start_quantity);
    // this.state.shift_data[index][identity] = data
  };

  render() {
    return (
      <PostJobView
        start_date={this.state.start_date}
        end_date={this.state.end_date}
        start_carer_type={this.state.start_carer_type}
        start_repeate_type={this.state.start_repeate_type}
        start_in_date={this.state.start_in_date}
        start_quantity={this.state.start_quantity}
        end_carer_type={this.state.end_carer_type}
        end_repeate_type={this.state.end_repeate_type}
        start_out_date={this.state.start_out_date}
        shift_timing={this.state.shift_timing}
        address={this.state.address}
        address_list={this.state.address_list}
        patient_name_validate={this.state.patient_name_validate}
        ed_time_validation={this.state.ed_time_validation}
        sd_time_validation={this.state.sd_time_validation}
        handelSummit={this.handelSummit}
        handleLangChange={(identity, date) =>
          this.handleLangChange(identity, date)
        }
        handelData={this.handelData}
        carer_type={this.state.carer_type}
        language={this.state.language}
        qualification={this.state.qualification}
        contract_type={this.state.contract_type}
        selectAllHandler={this.selectAllHandler}
        qualification_list={this.state.qualification_list}
        select_all={this.state.select_all}
        all_training={this.state.all_training}
        allTrainingHandle={this.allTrainingHandle}
        authResponse={this.state.authResponse}
        modal_show={this.state.modal_show}
        hideCustomModal={this.hideCustomModal}
        custom_model={this.state.custom_model}
        modal_id={this.state.modal_id}
        job_type={this.state.job_type}
        handelextrenssion={this.handelextrenssion}
        start_date_list={this.state.start_date_list}
        end_date_list={this.state.end_date_list}
        handelcompression={this.handelcompression}
        index={this.state.index}
        getDataPostCode={this.getDataPostCode}
        handelshiftData={this.handelshiftData}
        // start_date={this.state.start_date}
        hideAvailablityModal={this.hideAvailablityModal}
        showAvailablityModal={this.showAvailablityModal}
        hideSuccessModal={this.hideSuccessModal}
        showSuccessModal={this.showSuccessModal}
        Success_modal_boolean={this.state.Success_modal_boolean}
        modal_boolean={this.state.modal_boolean}
        availablitydada={this.availablitydada}
        SummitAvailablity={this.SummitAvailablity}
        selected_qualification={this.state.selected_qualification}
        experience={this.state.experience}
        hr_list={this.state.hr_list}
        min_list={this.state.min_list}
        repeate_list={this.state.repeate_list}
        dateModal={this.dateModal}
        handelShift={this.handelShift}
        handleMinusData={this.handleMinusData}
        shift_select_list={this.state.shift_select_list}
        weeek_check_boxes={this.state.weeek_check_boxes}
        weekDaysOnly={this.weekDaysOnly}
        changeValue={this.changeValue}
        /****
            shift_select_timing : ['All','Morning Shift - 5am to 9am','Mid Morning shift - 9am to noon','Day Shift - 7am to 6pm','Afternoon Shift - Noon to 4pm','Twilight Shift - 4pm to 10pm','Night Shift - 4pm to 8am','Swing Shift 10pm - 10am','Grave Shift - midnight to 10am','On-Call Shift - anytime day or night ', 'Weekend Shift - weekends only '],
        sh_modal_boolean:false,
    
            */ //
        shift_select_timing={this.state.shift_select_timing}
      />
    );
  }
}

export default PostJobComponent;
